module.exports = __webpack_public_path__ + "img/bg.9e7fdc70.jpg";